<template>
  <span style="vertical-align: middle;">
    <template v-if="workerType == '策划师'">
      <template v-if="score>=0&&score<=100">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=101&&score<=200">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=201&&score<=300">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=301&&score<=500">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=501&&score<=900">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=901&&score<=1400">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=1401&&score<=2000">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=2001&&score<=2700">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=2701&&score<=3500">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=3501&&score<=4500">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=4501&&score<=5600">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=5601&&score<=7200">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=7201&&score<=9000">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=9001&&score<=12000">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=12001&&score<=16000">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
    </template>
    <template v-if="workerType != '策划师'">
      <template v-if="score>=0&&score<=100">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=101&&score<=200">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=201&&score<=450">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=451&&score<=800">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=801&&score<=1400">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
        <img  src="../../assets/images/heart-s.png">
      </template>
      <template v-else-if="score>=1401&&score<=2200">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=2201&&score<=3200">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=3201&&score<=4400">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=4401&&score<=5800">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=5801&&score<=7400">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
        <img  src="../../assets/images/dengji2.png">
      </template>
      <template v-else-if="score>=7401&&score<=9400">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=9401&&score<=12000">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=12001&&score<=15000">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=15001&&score<=19000">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
      <template v-else-if="score>=19001&&score<=24000">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
        <img  src="../../assets/images/dengji3.png">
      </template>
    </template>
  </span>
</template>
<script>
  export default{
    name:'rank',
    props:['votype','rankvalue'],
    data:function () {
      return{
        score:this.rankvalue,
        workerType:this.votype
      }
    }
  }
</script>



// WEBPACK FOOTER //
// _rank.vue?6c9bd25c